import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import { SubmitButton } from '../../component/SubmitButton';
import { boxStatus } from '../../enum/boxStatus';
import { customerRole } from '../../enum/customerRole';
import { useState, useEffect } from 'react';
import useAlert from '../../component/Alert/useAlert';
import BoxAPI from '../../services/box.api.service';
import CustomerAPI from '../../services/customer.api.service';
import { BoxSelector } from '../../component/BoxSelector';
import { ContextSelect } from '../../component/ContextSelect';
import { CustomerSelector } from '../../component/CustomerSelector';
import Title from '../../component/Title';


const roles = [
    customerRole.producer,
    customerRole.logistics,
    customerRole.distributor,
    customerRole.reseller,
];

const destRoles = [
    customerRole.logistics,
    customerRole.distributor,
    customerRole.reseller,
];

const NftSelling = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: null,
        customers: [],
        customer: null,
        destination: null,
        quantity: null,
        box: null,
        loading: false,
    })

    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    useEffect(() => {
        if (!state.context) {
            return;
        }
        startLoading();
        CustomerAPI
            .getCustomers(state.context.id)
            .then(result => changeState({customers: result.items}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading())
    }, [state.context]);

    const handleSubmit = () => {
        startLoading();
        BoxAPI
            .transfer(state.box.hash, state.customer.id, state.destination.id)
            .then(() => {
                showSuccessAlert('NFT successfully transferred');
                changeState({box: ''});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    }

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box sx={{width: '100%'}}>
                <ContextSelect onContextChange={context => changeState({context})} />
                <CustomerSelector
                    context={state.context}
                    roles={roles}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title>Select a specific NFT</Title>
                <BoxSelector
                    customer={state.customer}
                    onBoxChange={box => changeState({box})}
                    selectedBox={state.box}
                    boxStatus={boxStatus.active}
                />
                <Title>Select NFT destination</Title>
                <CustomerSelector
                    context={state.context}
                    roles={destRoles}
                    onCustomerSelect={destination => changeState({destination})}
                />
                <SubmitButton
                    loading={state.loading}
                    disabled={state.loading || !state.box || !state.destination}
                    handleSubmit={handleSubmit}
                    text="Transfer NFT"
                />
            </Box>
        </Paper>
    );
};

export default NftSelling;
